/* eslint-disable max-len */
export enum CoachStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
}

export enum ActivityTypeEnum {
  SITUATIONAL = 'SITUATIONAL',
  ONETIME = 'ONETIME',
  RECCURENT = 'RECCURENT',
}

export enum IdentityProviderEnum {
  GOOGLE = 'Google',
  FACEBOOK = 'Facebook',
}

export const timeZoneOptions = [
  { value: 'Asia/Colombo', label: 'addNewCoach.timeZoneOptions.sriJayawardenepura' },
  { value: 'Asia/Singapore', label: 'addNewCoach.timeZoneOptions.kualaLumpurSingapore' },
  { value: 'Atlantic/Azores', label: 'addNewCoach.timeZoneOptions.azores' },
  { value: 'Asia/Kuwait', label: 'addNewCoach.timeZoneOptions.kuwaitRiyadh' },
  { value: 'Asia/Muscat', label: 'addNewCoach.timeZoneOptions.abuDhabiMuscat' },
];

export const coachTypeOptions = [
  { value: 'PS', label: 'coachTypes.PS' },
  { value: 'CN', label: 'coachTypes.CN' },
  { value: 'NLP', label: 'coachTypes.NLP' },
  { value: 'LC', label: 'coachTypes.LC' },
  { value: 'WC', label: 'coachTypes.WC' },
  { value: 'SC', label: 'coachTypes.SC' },
  { value: 'SPC', label: 'coachTypes.SPC' },
  { value: 'EP', label: 'coachTypes.EP' },
  { value: 'MFT', label: 'coachTypes.MFT' },
  { value: 'CWC', label: 'coachTypes.CWC' },
  { value: 'ST', label: 'coachTypes.ST' },
  { value: 'AC', label: 'coachTypes.AC' },
  { value: 'COC', label: 'coachTypes.COC' },
  { value: 'CC', label: 'coachTypes.CC' },

  // { value: 'SW', label: 'coachTypes.SW' },
];

export const coachDescriptions = {
  PS: 'coachDescriptions.PS',
  CN: 'coachDescriptions.CN',
  NLP: 'coachDescriptions.NLP',
  LC: 'coachDescriptions.LC',
  WC: 'coachDescriptions.WC',
  SC: 'coachDescriptions.SC',
  EP: 'coachDescriptions.EP',
  MFT: 'coachDescriptions.MFT',
  CWC: 'coachDescriptions.CWC',
  SW: 'coachDescriptions.SW',
  COC: 'coachDescriptions.COC',
  CC: 'coachDescriptions.CC',
};

export const AIModelOptions = [
  { value: 'MISTRAL', label: 'Mistral' },
  { value: 'OPENAI', label: 'Open AI' },
];

export const therapyTypes = [
  {
    type: 'PS',
    values: [
      'therapyTypes.PS.CBT',
      'therapyTypes.PS.PT',
      'therapyTypes.PS.NA',
      'therapyTypes.PS.DBT',
      'therapyTypes.PS.ACT',
    ],
  },
  {
    type: 'CN',
    values: [
      'therapyTypes.CN.IC',
      'therapyTypes.CN.GT',
      'therapyTypes.CN.GC',
      'therapyTypes.CN.CI',
      'therapyTypes.CN.SFBT',
    ],
  },
  {
    type: 'LC',
    values: [
      'therapyTypes.LC.GSA',
      'therapyTypes.LC.PGD',
      'therapyTypes.LC.CC',
      'therapyTypes.LC.RC',
      'therapyTypes.LC.SM',
    ],
  },
  {
    type: 'NLP',
    values: [
      'therapyTypes.NLP.BCT',
      'therapyTypes.NLP.PM',
      'therapyTypes.NLP.GSNLPF',
      'therapyTypes.NLP.COE',
      'therapyTypes.NLP.PES',
    ],
  },
  {
    type: 'WC',
    values: [
      'therapyTypes.WC.NC',
      'therapyTypes.WC.SRT',
      'therapyTypes.WC.EFP',
      'therapyTypes.WC.WM',
      'therapyTypes.WC.LCC',
    ],
  },
  {
    type: 'SC',
    values: [
      'therapyTypes.SC.AA',
      'therapyTypes.SC.CE',
      'therapyTypes.SC.SST',
      'therapyTypes.SC.BI',
      'therapyTypes.SC.CAG',
    ],
  },
  {
    type: 'SPC',
    values: [
      'therapyTypes.SPC.MC',
      'therapyTypes.SPC.PAM',
      'therapyTypes.SPC.FCE',
      'therapyTypes.SPC.TDC',
      'therapyTypes.SPC.GSFA',
    ],
  },
  {
    type: 'EP',
    values: [
      'therapyTypes.EP.LDA',
      'therapyTypes.EP.EPD',
      'therapyTypes.EP.BMS',
      'therapyTypes.EP.IQT',
      'therapyTypes.EP.SSE',
    ],
  },
  {
    type: 'MFT',
    values: [
      'therapyTypes.MFT.CT',
      'therapyTypes.MFT.FST',
      'therapyTypes.MFT.CW',
      'therapyTypes.MFT.CR',
      'therapyTypes.MFT.PC',
    ],
  },
  {
    type: 'CWC',
    values: [
      'therapyTypes.CWC.EWP',
      'therapyTypes.CWC.SMW',
      'therapyTypes.CWC.HLA',
      'therapyTypes.CWC.TBA',
      'therapyTypes.CWC.EA',
    ],
  },
  {
    type: 'ST',
    values: [
      'therapyTypes.ST.AT',
      'therapyTypes.ST.LI',
      'therapyTypes.ST.VDT',
      'therapyTypes.ST.FS',
      'therapyTypes.ST.AAC',
    ],
  },
  {
    type: 'AC',
    values: [
      'therapyTypes.AC.SUDC',
      'therapyTypes.AC.RPP',
      'therapyTypes.AC.GSS',
      'therapyTypes.AC.MI',
      'therapyTypes.AC.FTA',
    ],
  },
  {
    type: 'COC',
    values: [
      'therapyTypes.COC.LD',
      'therapyTypes.COC.CM',
      'therapyTypes.COC.TBD',
      'therapyTypes.COC.EI',
      'therapyTypes.COC.TM',
      'therapyTypes.COC.CS',
      'therapyTypes.COC.SM',
    ],
  },
  {
    type: 'CC',
    values: [
      'therapyTypes.CC.CTC',
      'therapyTypes.CC.CPP',
      'therapyTypes.CC.SSA',
      'therapyTypes.CC.PB',
      'therapyTypes.CC.WLB',
      'therapyTypes.CC.NS',
      'therapyTypes.CC.GSA',
    ],
  },
];

export enum SubscriptionPlanTypes {
  FREE_TRIAL = 'FREE_TRIAL',
  PREMIUM = 'PREMIUM',
  NONE = 'NONE',
  FREE = 'FREE',
  ULTIMATE = 'ULTIMATE',
  PRO = 'PRO',
  STARTER = 'STARTER',
}

export enum UserStatusType {
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
}

export enum CoachBrandTagsTypes {
  ALL = 'All',
  IHTP = 'ihtp',
  PGM = 'PGM',
}

export const CoachBrandTags = [
  {
    label: 'common.all',
    value: CoachBrandTagsTypes.ALL,
  },
  {
    label: 'IHTP',
    value: CoachBrandTagsTypes.IHTP,
  },
  {
    label: 'ProgressMagic',
    value: CoachBrandTagsTypes.PGM,
  },
];
